import React from 'react';
import Form from './Form';
import { PORTAL_ACCOUNT_INFO } from './graphql';
import { Query } from 'react-apollo';

const Card = (props) => {
    const id = ''
    const variables = {
        id
    }
    return (
        <div className="card">
            <div className="card-header">
                <div className="row align-items-center">
                    <div className="col-12">
                        <h3 className="mb-0">Minha Conta</h3>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <Query
                    query={PORTAL_ACCOUNT_INFO}
                    variables={variables}
                    notifyOnNetworkStatusChange
                >
                    {({ loading, error, data, refetch }) => {
                       return(
                            <Form props={data}/>
                       )
                    }}
                </Query>
            </div>
        </div>
    )
};

export default Card;


// WEBPACK FOOTER //
// ./src/components/Pages/Account/Card.js